module.exports = __webpack_public_path__ + "static/img/index-bg.bb88685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-bg.jpg
// module id = bMg+
// module chunks = 1